export const settingsHubEs = {
  title: 'Configuración',
  subtitle: 'Todas las áreas de configuración del inquilino en un solo lugar.',
  personal: 'Personal',
  configuration: 'Configuración',
  empty: 'No hay áreas de configuración disponibles para su rol.',
  areas: {
    setup: {
      title: 'Configuración y comprobación',
      description: 'Configuración guiada del tenant, progreso, pruebas y aprobación.',
    },
    profile: {
      title: 'Mi perfil',
      description: 'Nombre, idioma y preferencias de visualización.',
    },
    security: {
      title: 'Seguridad',
      description: 'Contraseña, autenticación de dos factores y sesiones activas.',
    },
    company: {
      title: 'Perfil de empresa',
      description:
        'Datos maestros, datos bancarios, ID de IVA y textos predeterminados de documentos.',
    },
    users: {
      title: 'Usuarios y roles',
      description:
        'Cuentas del equipo, matriz de permisos RBAC y autenticación de dos factores obligatoria.',
    },
    pdfDesigner: {
      title: 'Diseñador de PDF',
      description: 'Plantillas de arrastrar y soltar para cotizaciones, pedidos y facturas.',
    },
    documentHeaders: {
      title: 'Datos del cliente en cabeceras',
      description: 'Gestione campos, secciones y visibilidad por tipo de documento.',
    },
    accounting: {
      title: 'DATEV e Intrastat',
      description:
        'Asignación de cuentas SKR03/04, número de asesor y cliente, ejecuciones de informes.',
    },
    banking: {
      title: 'Banca y conciliación',
      description: 'AISP, sincronización, conciliación, cuentas y perfiles de importación seguros.',
    },
    whatsapp: {
      title: 'API de WhatsApp Business',
      description: 'Tokens de API de Meta Cloud, webhooks y plantillas de mensajes.',
    },
    notifications: {
      title: 'Notificaciones',
      description: 'Reglas para stock mínimo, advertencias de fecha de caducidad y pagos.',
    },
    salesRules: {
      title: 'Reglas comerciales y atención al cliente',
      description: 'Simule recomendaciones, mantenga umbrales y programe ejecuciones automáticas.',
    },
    translations: {
      title: 'Idiomas y traducciones',
      description: 'Gestione terminología del inquilino y nombres protegidos.',
    },
    customFields: {
      title: 'Campos personalizados y bóveda GoBD',
      description:
        'Campos adicionales dinámicos y registros de cambios a prueba de manipulaciones.',
    },
    system: {
      title: 'Sistema y copias de seguridad',
      description:
        'Prueba SMTP, copias de seguridad de la base de datos, importación/exportación y telemetría.',
    },
  },
  links: {
    setup: 'Abrir configuración',
    company: 'Editar datos de la empresa',
    users: 'Gestión de usuarios',
    roles: 'Roles y permisos',
    securityLog: 'Registro de seguridad',
    templates: 'Plantillas de documentos',
    documentHeaders: 'Datos del cliente en cabeceras',
    accounting: 'Mapeo de cuentas',
    datev: 'Exportación DATEV',
    intrastat: 'Informe Intrastat',
    banking: 'Configurar banca',
    whatsapp: 'Conexión y plantillas',
    notifications: 'Reglas de alertas',
    salesRules: 'Gestionar reglas comerciales',
    translations: 'Glosario de traducción',
    customFields: 'Campos personalizados',
    auditVault: 'Bóveda GoBD',
    system: 'Salud del sistema',
    errorLogs: 'Centro de errores',
    mailBackups: 'Servidor de correo y copias de seguridad',
    dataHub: 'Importar y exportar',
  },
} as const;
